<template>
  <div class="div3 cutbox">

      <div class="text1">
        <span data-range="4,6" data-id="主标题1" :data-attr="info.titles[0]"><em></em>{{
          info.titles[0]
        }}<em></em></span>
      </div>
      <div class="text2">
        <span data-range="4,6" data-id="主标题2" :data-attr="info.titles[2]">{{ info.titles[2]
        }}<em></em></span>
      </div>
      <div class="text3" data-id="长特点1" data-range="12,28">
        {{ info.specialty[0] }}
      </div>

    <div class="text4"><img :src="info.image" alt=""></div>

      <div class="text5" data-id="长特点2" data-range="10,15">{{ info.specialty[1] }}</div>
      <div class="text6" data-id="公司" data-range="8,26">{{ info.company }}</div>

  </div>
</template>
<script>
export default {
  name: 'TUWEN003',
  props: {
    info: Object
  },
}
</script>
